(function () {
'use strict';

angular.module('hyresgastApp').controller('ListNegotiationResponsiblesCtrl', ListNegotiationResponsiblesCtrl);

function ListNegotiationResponsiblesCtrl(
  $scope, $location, $filter,
  Negotiation,
  CombinedNegotiationStates, NegotiationTypes, Limits
) {
  var vm = this;
  vm.statusChoices = Object.values(CombinedNegotiationStates).map(x => ({
    id: x,
    text: $filter('hyCombinedNegotiationStates')(x)
  }));
  vm.negotiationTypeChoices = Object.values(NegotiationTypes).map(x => ({
    id: x,
    text: $filter('hyNegotiationTypes')(x)
  }));
  vm.pageLimit = 30;
  vm.tableColumns = [{
    title: 'Id',
    column: 'caseNumber'
  },
  {
    title: 'Förhandlare',
    column: 'participants.firstname',
    template: 'person',
  },
  {
    title: 'Namn',
    column: 'name'
  },
  {
    title: 'Organisation',
    column: 'counterpart.name'
  },
  {
    title: 'Kontor',
    column: 'office.name'
  },
  {
    title: 'Förhandlingstyp',
    template: 'slot1',
    column: 'type',
    lookup: {
      idProperty: 'id',
      textProperty: 'text',
      dictionary: vm.negotiationTypeChoices,
      multi: true,
    },
  },
  {
    title: 'Status',
    template: 'status',
    column: 'combinedState',
    lookup: {
      idProperty: 'id',
      textProperty: 'text',
      dictionary: vm.statusChoices,
      multi: true,
    },
  },
  {
    title: 'Önskat datum för förhandling',
    column: 'callForNegotiation.negotiationDate'
  }
  ];

  vm.gotoNegotiation = (negotiation) => {
    $location.search({});
    $location.path('/negotiations/' + negotiation.id);
  }

  let getParams = (includeProperties) => {
    let tableauParams = vm.lastParams;
    tableauParams.limit = Limits.InMemoryMiddleLimit;
    tableauParams.offset = 0;
    if (includeProperties) {
      tableauParams.includeProperties = includeProperties;
    }
    return tableauParams;
  };

  vm.getAllNegotiations = (cb, includeProperties) => {
    Negotiation.queryByChief(getParams(includeProperties), {})
      .$promise.then(function (data) { cb(data) });
  };

  vm.tableFGetData = Negotiation.queryByChief;
}
})();